import actions from './actions';

const initState = {
    data: [],
    selectedEquipmentCategory: []
};

export default function EquipmentCategoryReducer(state = initState, action) {
    switch (action.type) {
        case actions.EquipmentCategory_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        case actions.SELECTED_EquipmentCategory:
            return {
                ...state,
                selectedEquipmentCategory: action.payload.data
            };
        default:
            return state;
    }
}
